// extracted by mini-css-extract-plugin
module.exports = {"goBackArrow":"EditRightModal_goBackArrow__TkhQb"};